<template>
    <div class="page-wrapper">
        <NavBar class="style1" />
        <div class="content-wrapper">
            <PageTitle pageTitle="Bibliotheque" />
            <BiblioTheque />
        </div>
        <FooterComp />
    </div>
</template>

<script>
import NavBar from '../Layouts/NavBar'
import PageTitle from '../Common/PageTitle'

import FooterComp from '../Layouts/FooterComp'
import BiblioTheque from '../Bibliotheque/BiblioTheque.vue';


export default {
    name: 'BibliothequePage',
    components: {
        NavBar,
        PageTitle,
        BiblioTheque,
        FooterComp,
    }
}
</script>